import CalendarEventModal from "./CalendarEventModal";

export default CalendarEventModal;